import { useEffect, useState } from 'react';
import Screen from '../../components/layout/Screen';
import ScrollableContainer from '../../components/ScrollableContainer';
import { useNavigate, useParams } from 'react-router';
import BooksService from '@/common/API/BooksService';
import { BookType } from '@/common/types/BookType';
import SectionTitle from '@/components/SectionTitle';
import { ListApiInfinite } from '@/components/List';
import QuotesService from '@/common/API/QuotesService';
import { useData } from '@/common/hooks/useData';
import { useDialog } from '@/common/hooks/useDialog';
import useForceRefetch from '@/common/hooks/useForceRefetch';
import BooksEditScreen from './BooksEditScreen';
import { HiOutlinePencilSquare } from 'react-icons/hi2';
import { getGenre } from '@/common/static/genresList';
import { Link } from 'react-router-dom';
import { GoTrash } from 'react-icons/go';

const BooksPreviewScreen = () => {
  const { id } = useParams<{ id: any }>();
  const [bookData, setBookData] = useState<BookType | null>(null);
  const { tags } = useData();
  const { openDrawer, closeDrawer } = useDialog();
  const { shouldRefetch, forceRefetch } = useForceRefetch();
  const navigate = useNavigate();

  useEffect(() => {
    BooksService.one(id).then((res: any) => {
      setBookData(res.data);
      console.log(res.data);
    });
  }, [id, tags]);

  const onDelete = (id: number) => {};

  return (
    <Screen
      screenContainerClassName='bg-black'
      screenOptions={{
        header: {
          title: bookData ? bookData['name'] : 'Book',
          backBtnLabel: 'Books',
          backBtnUrl: '/books',
          titleClassName: 'text-white',
          rightContent: (
            <button
              onClick={() => {
                openDrawer({
                  content: (
                    <BooksEditScreen
                      id={id}
                      onSuccess={() => {
                        forceRefetch();
                        closeDrawer();
                      }}
                    />
                  ),
                });
              }}
              className='text-blue-500 dark:text-orange-500 text-xl'
            >
              <HiOutlinePencilSquare />
            </button>
          ),
        },
      }}
    >
      <ListApiInfinite<any>
        queryKey={['book-quotes', shouldRefetch]}
        queryFn={({ pageParam }) =>
          QuotesService.all({
            page: pageParam,
            bookId: id,
            per_page: 20,
          })
        }
        containerClassName='h-full px-4'
        renderItem={(item, i) => {
          return (
            <section key={item.id} className=' w-full grid grid-cols-5'>
              <div
                onClick={() => {
                  navigate(`quotes/${item.id}`, { relative: 'path' });
                }}
                className='col-span-4'
              >
                <div className='p-4'>
                  <span className='block mb-1 text-xs text-white/40'>Quote</span>
                  <div
                    className=' w-full truncate'
                    dangerouslySetInnerHTML={{
                      __html: item.text,
                    }}
                  ></div>
                </div>
              </div>
              <div className='col-span-1 p-4 flex items-center justify-center' onClick={() => onDelete(item.id)}>
                <GoTrash />
              </div>
            </section>
          );
        }}
        header={
          <>
            <section className='grid grid-cols-4 w-full my-2'>
              <div className='col-span-1 h-auto flex items-center justify-center rounded-xl'>
                <img src={bookData?.image?.url} className='object-cover rounded-xl' alt='' />
              </div>
              <div className='col-span-3 pl-4 flex justify-center flex-col'>
                <h1 className='w-full text-xl font-bold text-white'>{bookData?.name}</h1>
                <div>
                  <span className='text-xs text-white/40'>Author</span>
                  <h3 className='text-sm text-neutral-300'>{bookData?.author.name}</h3>
                </div>
                <div>
                  <span className='text-xs text-white/40'>Genre</span>
                  <h3 className='text-sm text-neutral-300'>{getGenre(bookData?.genre)?.name}</h3>
                </div>
              </div>
            </section>
            <SectionTitle className='text-white mb-3 mt-4' label='Quotes' />
          </>
        }
      />
    </Screen>
  );
};

export default BooksPreviewScreen;
